import { motion } from "motion/react";
import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";
import { SiteFooter } from "@/src/common/components/site-footer";
import { SiteHeader } from "@/src/common/components/site-header";

export function SiteLayout() {
	const { pathname } = useLocation();
	const isFirstRender = useRef(true);
	const previousPathname = useRef(pathname);

	useEffect(() => {
		isFirstRender.current = false;
	}, []);

	useEffect(() => {
		if (previousPathname.current === pathname) return;
		previousPathname.current = pathname;
		window.scrollTo({ top: 0, behavior: "instant" });
	}, [pathname]);

	return (
		<div className="flex min-h-screen flex-col bg-background text-foreground">
			<SiteHeader />
			<main className="flex-1">
				<motion.div
					key={pathname}
					initial={isFirstRender.current ? false : { opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.2, ease: "easeOut" }}
				>
					<Outlet />
				</motion.div>
			</main>
			<SiteFooter />
		</div>
	);
}
